export const storeName = 'FreeSamples';

export default {
    INITIALIZE: `${storeName}.INITIALIZE`,
    SET_PRODUCTS: `${storeName}.SET_PRODUCTS`,
    LOAD_SAMPLES: `${storeName}.LOAD_SAMPLES`,
    REMOVE_SAMPLES: `${storeName}.REMOVE_SAMPLES`,
    SET_REMOVE_SAMPLES_CHECKBOX: `${storeName}.SET_REMOVE_SAMPLES_CHECKBOX`,
    SET_CATEGORY_CODE: `${storeName}.SET_CATEGORY_CODE`,
    SET_LOADING: `${storeName}.SET_LOADING`,
    SET_CLICKED_SAMPLE: `${storeName}.SET_CLICKED_SAMPLE`,
    SET_HIDE_FREE_SAMPLES: `${storeName}.SET_HIDE_FREE_SAMPLES`,
    SET_ALLOWED_SAMPLES_CHANGED: `${storeName}.SET_ALLOWED_SAMPLES_CHANGED`,
};
